import Image from 'app/Components/Shared/Image/image';
import React, {useRef, useState, useEffect} from 'react';
import {Container} from 'reactstrap';
import './TextFieldWithRadio.scss';

const TextFieldWithRadio = ({fields, onChange, selectedForm, setSelectedForm}) => {
  const inputRefs = useRef({});
  const [onFocus, setOnFocus] = useState(false);

  const handleClick = (fieldKey) => {
    setSelectedForm(fieldKey);
    inputRefs.current[fieldKey].current.disabled = false;
    inputRefs.current[fieldKey].current.focus();
  };

  const handleTextFieldChange = (event, fieldKey) => {
    if (onChange) {
      onChange({
        field: fieldKey,
        value: event.target.value,
      });
    }
  };

  useEffect(() => {
    Object.keys(fields).forEach((fieldKey) => {
      inputRefs.current[fieldKey] = React.createRef();
    });
  }, []);

  return (
    <div className='text-field-with-radio'>
      {Object.keys(fields).map((fieldKey) => {
        const field = fields[fieldKey];
        return (
          <div className='d-flex flex-column' key={fieldKey}>
            <Container
              className='text-field-with-radio-container p-0'
              role={fieldKey !== undefined ? 'button' : null}
              onClick={() => handleClick(fieldKey)}
              tabIndex={fieldKey}>
              <div className='input-info' key={fieldKey}>
                <div className='text-field-with-radio-content'>
                  <div className={`${selectedForm === fieldKey ? 'active' : ''} info`}>
                    {fieldKey !== null && (
                      <div>
                        <Image src={selectedForm === fieldKey ? require('./images/radio-fill.svg') : require('./images/radio-empty.svg')}
                          alt='' />
                      </div>
                    )}
                    <div className='info-details'>
                      <div className='text-field-with-radio-input bold'>
                        {!onFocus && field?.preText && field[fieldKey] ? field?.preText : null}
                        <input
                          ref={inputRefs.current[fieldKey]}
                          type='text'
                          value={field[fieldKey]}
                          disabled={selectedForm !== fieldKey}
                          placeholder={field?.placeholder}
                          maxLength={field?.maxLength}
                          onChange={(event) => handleTextFieldChange(event, fieldKey)}
                          onFocus={() => {
                            setOnFocus(true);
                          }}
                          onBlur={() => {
                            setOnFocus(false);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
            <p className='text-field-with-radio-error align-self-start'>{field?.errors[fieldKey]}</p>
          </div>
        );
      })}
    </div>
  );
};

export default TextFieldWithRadio;
